import React, { useEffect, useState } from 'react';
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { Button, Image } from '@applane/react-core-components';
import { Text } from 'react-native';
import {
  handleCardActionResponse,
  stripePaymentMethodHandler,
} from './PaymentScript';
import { View, Toast } from '../app-components';
import { getUser, invoke } from '../AppServices';
import { validateEmail } from '../Lib/helpers';
import { closeIcon } from '../images';

const PaymentFormTheme = {
  boundry: {
    border: '1px solid grey',
    borderRadius: '7px',
    width: 600,
    height: 'auto',
    justifyContent: 'center',
  },
  boxToHoldForm: {
    margin: '10px 5px',
  },
  boxToHoldName: {
    margin: '5px 0px',
    // width: '45%',
    width: '90%',
  },
  boxToHoldEmail: {
    margin: '5px 0px',
    // width: '45%',
    width: '90%',
  },
  boxToHoldCardNumber: {
    margin: '5px 0px',
    // padding: '0px 5px',
    width: '90%',
  },
  flexBoxToHoldCardNumber: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '5px 0px',
  },
  boxToHoldExpiryDate: {
    margin: '5px',
  },
  boxToHoldCVV: {
    margin: '5px',
    width: '20%',
  },

  boxToHoldNameAndEmail: {
    display: 'flex',
    // flexDirection: 'row',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },

  boxToHoldExpiryDateAndCVV: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  boxToHoldSubmitButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '10px 0px',
    border: '1px solid red',
  },

  payTitle: {
    paddingLeft: '32px',
    fontSize: '18px',
    marginTop: '5px',
  },

  flexBoxToHoldButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '5px 0px',
    // border: '1px solid red',
  },

  boxToHoldPayButton: {
    width: '38%',
  },

  boxToHoldCloseButton: {
    display: 'flex',
    flexDirection: 'row-reverse',
    paddingTop: '10px',
    paddingRight: '10px',
  },

  closeButtonProperties: {
    color: 'red',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      lineHeight: '27px',
      color: '#111111',
      fontSize: '1.1rem',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  },
};

export default function CheckoutForm(propsForPayment) {
  const { navigation } = propsForPayment;
  const [loading, setLoading] = useState(false);
  const [closeButtonHover, setCloseButtonHover] = useState(false);

  const [nameError, setNameError] = useState('no-error');
  const [emailError, setEmailError] = useState('no-error');
  const [emptyFieldsError, setEmptyFieldsError] = useState('');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const stripe = useStripe();
  const elements = useElements();
  useEffect(() => {
    if (name === '') {
      setNameError('name-error');
    } else {
      setNameError('no-error');
    }
  }, [name]);

  useEffect(() => {
    if (email === '') {
      setEmailError('empty-error');
    } else if (validateEmail(email)) {
      setEmailError('invalid-error');
    } else {
      setEmailError('no-error');
    }
  }, [email]);

  // callback method to handle the response
  const handleResponse = async (response) => {
    const { intentStatus, charges, error } = response;
    setLoading(false);

    if (error) {
      setEmptyFieldsError(error);
    }
    // if (response?.error?.message) {
    //   setEmptyFieldsError(response.error.message);
    // }
    let forToast = false;

    if (response.requires_action) {
      const cardActionResult = await stripe
        .handleCardAction(response.payment_intent_client_secret)
        .then((res) => handleCardActionResponse(res));

      // console.log('card action result ->', cardActionResult);

      forToast = !!cardActionResult.result;
      propsForPayment.setWhatToShow(
        cardActionResult.result ? 'success' : 'fail',
      );
    }

    let tid = 'N.A.';

    if (intentStatus === 'succeeded') {
      forToast = true;
      tid = charges?.data[0]?.balance_transaction
        ? charges?.data[0]?.balance_transaction
        : 'N.A.(transaction id not found)';
      propsForPayment.setWhatToShow('success');

      const reciptLink = charges?.data[0]?.receipt_url;
      if (reciptLink) {
        window.open(reciptLink, '_blank');
      }
    }

    if (forToast) {
      const dealer = {};
      const end = new Date();
      end.setDate(end.getDate() + 30);

      dealer.planId = 'N.A.';
      dealer.expire = end;
      dealer.paymentMode = navigation.state.params.paymentMode;
      const { dealerId } = navigation.state.params;
      dealer.paymentStatus = 'Complete';
      dealer.activityStatus = 'Active';

      await invoke({
        id: 'handleDealerSubscriptionPlanBuy',
        paramValue: { data: dealer, dealerId },
      });

      const history = {
        dealerId: { _id: dealerId },
        transactionId: tid,
        price: navigation.state.params.price,
        transactionDateTime: new Date(),
        transactionMode: 'CC',
        purchasedByName: getUser().username,
      };

      await invoke({
        id: 'addSubscriptionHistoryRecord',
        paramValue: { data: history },
      });

      Toast.show({
        message: 'Success',
        description: 'Plan Successfully purchased',
        type: 'success',
        position: 'top',
        direction: 'right',
      });
    } else {
      Toast.show({
        message: 'Error',
        description: 'Payment Failed',
        type: 'error',
        position: 'top',
        direction: 'right',
      });
    }
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!name || !email) {
      setEmptyFieldsError('All the fields are required!');
      return;
    }
    setEmptyFieldsError('');

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    if (nameError !== 'no-error' && emailError !== 'no-error') {
      return;
    }

    setLoading(true);

    const paymentMethodObj = {
      type: 'card',
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name,
        email,
      },
    };

    const paymentMethodResult = await stripe.createPaymentMethod(
      paymentMethodObj,
    );

    stripePaymentMethodHandler(
      {
        result: paymentMethodResult,
        amount: propsForPayment.amount,
        description: navigation?.state?.params?.dealerUsername
          ? navigation?.state?.params?.dealerUsername
          : 'no-username',
      },
      handleResponse,
    );
  };

  return (
    <View style={PaymentFormTheme.boundry}>
      <View style={PaymentFormTheme.boxToHoldCloseButton}>
        <Button
          onMouseOver={() => setCloseButtonHover(true)}
          onMouseLeave={() => setCloseButtonHover(false)}
          onFocus={() => setCloseButtonHover(true)}
          style={PaymentFormTheme.closeButtonProperties}
          onClick={() => {
            if (!loading) {
              propsForPayment.navigation.pop();
            }
          }}
        >
          <Image
            source={closeIcon}
            style={{
              border: closeButtonHover
                ? '1px solid grey'
                : '1px solid transparent',
            }}
          />
        </Button>
      </View>
      <View style={PaymentFormTheme.payTitle}>Pay With Card</View>
      <View style={PaymentFormTheme.boxToHoldForm}>
        <form onSubmit={handleSubmit}>
          <View style={PaymentFormTheme.boxToHoldNameAndEmail}>
            <View style={PaymentFormTheme.boxToHoldName}>
              <label htmlFor="name">Name</label>
              <input
                style={{
                  height: '35px',
                  borderRadius: '5px',
                  paddingLeft: '4px',
                  border:
                    nameError === 'no-error'
                      ? '1px solid grey'
                      : '1px solid red',
                  outline: '0px',
                  color: 'grey',
                }}
                name="name"
                id="name"
                type="text"
                value={name}
                placeholder="Enter name"
                onChange={(e) => {
                  if (!loading) {
                    setName(e.target.value);
                  }
                }}
              />
            </View>
            <View style={PaymentFormTheme.boxToHoldEmail}>
              <label htmlFor="email">Email</label>
              <input
                style={{
                  height: '35px',
                  borderRadius: '5px',
                  paddingLeft: '4px',
                  border:
                    emailError === 'no-error'
                      ? '1px solid grey'
                      : '1px solid red',
                  outline: '0px',
                  color:
                    emailError === 'no-error' || emailError === 'empty-error'
                      ? 'grey'
                      : 'red',
                }}
                name="email"
                id="email"
                type="text"
                value={email}
                placeholder="Enter email"
                onChange={(e) => {
                  if (!loading) {
                    setEmail(e.target.value);
                  }
                }}
              />
            </View>
          </View>
          <View style={PaymentFormTheme.flexBoxToHoldCardNumber}>
            <View style={PaymentFormTheme.boxToHoldCardNumber}>
              <label htmlFor="number">Card Number</label>
              <CardNumberElement
                id="number"
                className="form-control"
                options={CARD_ELEMENT_OPTIONS}
              />
            </View>
          </View>

          <View style={PaymentFormTheme.boxToHoldExpiryDateAndCVV}>
            <View style={PaymentFormTheme.boxToHoldExpiryDate}>
              <label htmlFor="expiry">Expiration Date</label>
              <CardExpiryElement
                id="expiry"
                className="form-control"
                options={CARD_ELEMENT_OPTIONS}
              />
            </View>

            <View style={PaymentFormTheme.boxToHoldCVV}>
              <label htmlFor="cvc">CVC</label>
              <CardCvcElement
                id="cvc"
                className="form-control"
                options={CARD_ELEMENT_OPTIONS}
              />
            </View>
          </View>

          {emptyFieldsError ? (
            <View style={{ padding: 20 }}>
              <Text style={{ textAlign: 'center', color: 'red' }}>
                {emptyFieldsError}
              </Text>
            </View>
          ) : null}

          <View style={PaymentFormTheme.flexBoxToHoldButton}>
            <View style={PaymentFormTheme.boxToHoldPayButton}>
              <button
                className="btn btn-info w-100"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <div
                    className="spinner-border spinner-border-sm text-light"
                    role="status"
                  />
                ) : (
                  `PAY $${propsForPayment.amount}`
                )}
              </button>
            </View>
          </View>
        </form>
      </View>
    </View>
  );
}
